import BaseApi from '@/api/BaseApi';
import type { IPaginate } from '@/models/TableSettingsModel';
import type { IChallengesItemList } from '@/models/ChallengesModel';

export default class ChallengeApi extends BaseApi {
    async challengeList (page: number, perPage: number, sortBy: string | null, sortDesc: string | null, search: string | null) {
        let url = `/api/challenges?page=${page}&per_page=${perPage}`;

        if (null != sortBy) {
            url += `&sort=${sortBy}`;
        }

        if (null != sortDesc) {
            url += `&order=${sortDesc}`;
        }

        if (null != search) {
            url += `&search=${search}`;
        }

        return this.get<IPaginate<IChallengesItemList>>({
            url: url,
        });
    };

    async oneChallengeList (id: number) {
        return this.get<IChallengesItemList>({
            url: `/api/challenges/${id}`,
        });
    };
};
